import Alpine from 'alpinejs';
import A11yDialog from 'a11y-dialog'

Alpine.data("transcriptApp", () => ({
    transcriptInit() {
        // Listen for custom events from searchApp
        window.addEventListener('show-transcript', (event) => {
            const transcriptPageId = document.querySelector('[data-book-page-id]').getAttribute('data-book-page-id');
            const {pageId, html} = event.detail;
            if (parseInt(transcriptPageId) === pageId) {
                this.highlightedTranscript = html;
                this.showSearchResult = true;
                this.showOriginal = false;
            }
        });

        window.addEventListener('clear-transcript', (event) => {
            const transcriptPageId = document.querySelector('[data-book-page-id]').getAttribute('data-book-page-id');
            const {pageId} = event.detail;
            if (parseInt(transcriptPageId) === pageId) {
                this.highlightedTranscript = '';
                this.showSearchResult = false;
                this.showOriginal = true;
            }
        });
    },
    showOriginal: true,
    showSearchResult: false,
    highlightedTranscript: '',
    dialog: null,
    async triggerPopupEssayModal(essayIdOrEvent) {
        const triggerElement = essayIdOrEvent?.currentTarget;
        // Works out if the buttons is passing the event triggered for a single essay via the popup button,
        // or if it's being triggered by the dropdown item being clicked which passes the essayId directly
        const essayId = triggerElement ? triggerElement.dataset.essayId : essayIdOrEvent;

        if (!essayId) {
            return;
        }

        try {
            const response = await fetch(`/essays/${essayId}/`);
            if (!response.ok) {
                throw new Error('Failed to retrieve essay content');
            }
            const html = await response.text();

            const modalContainer = document.querySelector('#popup-essay-content-modal');
            const modalContentTarget = modalContainer.querySelector('#popup-essay-html-container');

            if (!modalContainer || !modalContentTarget) {
                console.error('Modal container or content target not found');
                return;
            }

            modalContentTarget.innerHTML = html;

            // only instantiate once
            if (!this.dialog) {
                this.dialog = new A11yDialog(modalContainer);

                this.dialog.on('show', () => {
                    const scrollY = window.scrollY || document.documentElement.scrollTop;
                    document.body.style.setProperty('--scroll-y', `${scrollY}px`);
                    document.body.classList.add('modal--open');
                });

                this.dialog.on('hide', () => {
                    const scrollY = parseInt(document.body.style.getPropertyValue('--scroll-y') || '0');
                    document.body.classList.remove('modal--open');
                    window.scrollTo(0, scrollY);
                });
            }

            this.dialog.show();

        } catch (error) {
            console.error(error);
        }
    }
}));
